// Demographic Options Data
// Create initial state for a demographic card

export const createInitialDemographicState = () => {
  return {
    // Group-level fields
    groupTargetNumber: "",
    groupMaximumSamples: "",
    
    // Basic Demographic
    gender: { male: false, female: false },
    cities: {}, // For city selection
    age: {
      under18: false,
      "18-25": false,
      "26-29": false,
      "30-35": false,
      "36-39": false,
      "40-45": false,
      "46-49": false,
      "50plus": false,
    },
    marriage: {
      single: false,
      marriedNoChildren: false,
      marriedWithChildren: false,
      divorced: false,
    },
    education: {
      juniorHighBelow: false,
      highSchool: false,
      juniorCollege: false,
      bachelor: false,
      masterAbove: false,
    },
    personalMonthlyIncome: {
      below5000: false,
      "5000-10000": false,
      "10000-15000": false,
      "15000-20000": false,
      "20000-30000": false,
      "30000-50000": false,
      "50000plus": false,
    },
    familyMonthlyIncome: {
      below5000: false,
      "5000-7000": false,
      "7000-10000": false,
      "10000-20000": false,
      "20000-30000": false,
      "30000-50000": false,
      "50000-100000": false,
      "100000-200000": false,
      "200000plus": false,
    },
    avgMonthlySpending: {
      below5000: false,
      "5000-7000": false,
      "7000-10000": false,
      "10000-20000": false,
      "20000-30000": false,
      "30000-50000": false,
      "50000plus": false,
    },
    spendingHabits: {
      brandLoyal: false,
      rational: false,
      priceSensitive: false,
      impulse: false,
      selective: false,
      influenceable: false,
    },
    interestType: {
      miningLivestock: false,
      agricultureForestry: false,
      internetTech: false,
      healthcarePharma: false,
      educationTraining: false,
      accommodationCatering: false,
      retailWholesale: false,
      financeInsurance: false,
      transportLogistics: false,
      cultureEntertainment: false,
      constructionManufacturing: false,
      scientificResearch: false,
      aviationTourism: false,
    },

    // Career Industry
    careerIndustry: {
      travel: false,
      movies: false,
      sports: false,
      food: false,
      anime: false,
      learning: false,
      music: false,
      photography: false,
      boardGames: false,
      pets: false,
      handicrafts: false,
      collections: false,
      newsInfo: false,
      videoStreaming: false,
      socialNetworking: false,
      travelTransport: false,
    },

    // Hobbies and Interests - 16 options matching Chinese version
    hobbiesInterests: {
      travel: false,
      movies: false,
      sports: false,
      food: false,
      animeGames: false,
      reading: false,
      music: false,
      photography: false,
      boardGames: false,
      pets: false,
      handicrafts: false,
      collections: false,
      newsInfo: false,
      paidVideoStreaming: false,
      socialNetworking: false,
      travelTransport: false,
    },

    // App Categories - 9 options matching Chinese version
    appCategories: {
      gaming: false,
      reading: false,
      wealthMgmt: false,
      shopping: false,
      education: false,
      shortVideos: false,
      photoDesign: false,
      lifestyle: false,
      smartOffice: false,
    },

    // Living Arrangement
    livingArrangement: {
      liveAlone: false,
      withPartner: false,
      withSpouseChildren: false,
      withParents: false,
      withParentsSpouseChildren: false,
    },

    // Transportation
    transportation: {
      privateCar: false,
      carSharing: false,
      taxi: false,
      publicTransport: false,
      bicycle: false,
      motorcycle: false,
      ebike: false,
    },

    // Car Related - matching Chinese version
    carOwner: { yes: false, no: false },
    fuelType: { gasoline: false, hev: false, phev: false, ev: false },
    carType: { sedan: false, suv: false, mpv: false, sportsCar: false },
    paymentMethod: { fullPayment: false, installment: false },
    purchaseTime: {
      within1year: false,
      "1-2years": false,
      "2-3years": false,
      "3-5years": false,
      "5-8years": false,
      "8plusYears": false,
    },
    mileageDriven: {
      below10000: false,
      "10000-30000": false,
      "30000-50000": false,
      "50000-100000": false,
      "100000plus": false,
    },
    purchaseStatus: { newCar: false, usedCar: false },
    purchaseChannel: {
      "4sStore": false,
      tradingMarket: false,
      autoShow: false,
      groupBuying: false,
      onlinePlatform: false,
    },
    vehiclesOwned: {
      "1vehicle": false,
      "2vehicles": false,
      "3vehicles": false,
      moreThan3: false,
    },

    // Planned Purchase - matching Chinese version
    plannedPurchaseTime: {
      within6months: false,
      within1year: false,
      within2years: false,
      "2plusYears": false,
    },
    plannedPowertrainType: {
      fuelVehicle: false,
      hybrid: false,
      bev: false,
    },
    plannedVehicleType: { sedan: false, suv: false, mpv: false },
    plannedPurchaseStatus: { newCar: false, usedCar: false },
    carInfoSources: {
      tvRadio: false,
      videoMedia: false,
      socialMedia: false,
      liveStreaming: false,
      offlineStore: false,
      carMarket: false,
      internationalAutoShow: false,
      friendsFamily: false,
      autoForums: false,
      carMagazines: false,
      portalWebsites: false,
    },
    purchaseDecisionFactors: {
      dailyLifeNeeds: false,
      workLocation: false,
      financialImprovement: false,
      householdSize: false,
      familyStructure: false,
      socialNeeds: false,
      rideHailingDriver: false,
      statusImage: false,
    },

    // Specific Requirement
    specificRequirement: "",
  }
}

export default createInitialDemographicState
